import React from 'react'

const Mail = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M18.9027 5.2002H7.0973C4.61351 5.2002 2.60001 6.93487 2.60001 9.07471V17.7924C2.60001 19.9322 4.61351 21.6669 7.0973 21.6669H18.9027C21.3865 21.6669 23.4 19.9322 23.4 17.7924V9.07471C23.4 6.93487 21.3865 5.2002 18.9027 5.2002Z" stroke="currentColor" strokeWidth="1.8"></path>
<path d="M2.65247 9.77881L10.7181 14.4021C11.394 14.7943 12.1615 15.0009 12.943 15.0009C13.7244 15.0009 14.492 14.7943 15.1679 14.4021L23.2558 9.77881" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
</svg>
    )
}

export default Mail
